export default __webpack_public_path__ + "static/Plots0015-e5a4926de7ef2fa21fb135f0f502a14d.jpg";